/* tslint:disable */

declare var Object: any;
export interface SFBankTransferReportInterface {
  "id"?: number;
}

export class SFBankTransferReport implements SFBankTransferReportInterface {
  "id": number;
  constructor(data?: SFBankTransferReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFBankTransferReport`.
   */
  public static getModelName() {
    return "SFBankTransferReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFBankTransferReport for dynamic purposes.
  **/
  public static factory(data: SFBankTransferReportInterface): SFBankTransferReport{
    return new SFBankTransferReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFBankTransferReport',
      plural: 'SFBankTransferReports',
      path: 'SFBankTransferReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFBankTransferReport.ts